import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { PRODUCT_CATEGORIES, CATEGORY_LABELS } from '../../../constants/productsData';

const ProjectFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  activeFiltersCount 
}) => {
  const categoryTypes = [
    { value: 'all', label: 'Todas as Categorias', icon: 'Home' },
    { value: '0', label: CATEGORY_LABELS[0], icon: 'Sofa' },
    { value: '1', label: CATEGORY_LABELS[1], icon: 'Table' },
    { value: '2', label: CATEGORY_LABELS[2], icon: 'Chair' },
    { value: '3', label: CATEGORY_LABELS[3], icon: 'TreePine' },
    { value: '4', label: CATEGORY_LABELS[4], icon: 'UtensilsCrossed' },
    { value: '5', label: CATEGORY_LABELS[5], icon: 'Bed' },
    { value: '6', label: CATEGORY_LABELS[6], icon: 'Sparkles' }
  ];

  const styleTypes = [
    { value: 'all', label: 'Todos os Estilos', icon: 'Palette' },
    { value: 'modern', label: 'Moderno', icon: 'Square' },
    { value: 'classic', label: 'Clássico', icon: 'Crown' },
    { value: 'rustic', label: 'Rústico', icon: 'TreePine' },
    { value: 'contemporary', label: 'Contemporâneo', icon: 'Zap' },
    { value: 'minimalist', label: 'Minimalista', icon: 'Minus' }
  ];

  const budgetRanges = [
    { value: 'all', label: 'Todos os Orçamentos', icon: 'DollarSign' },
    { value: 'premium', label: 'Premium (R$ 50k+)', icon: 'Star' },
    { value: 'luxury', label: 'Luxo (R$ 30-50k)', icon: 'Diamond' },
    { value: 'standard', label: 'Padrão (R$ 15-30k)', icon: 'Circle' },
    { value: 'compact', label: 'Compacto (até R$ 15k)', icon: 'Square' }
  ];

  const handleFilterClick = (filterType, value) => {
    onFilterChange(filterType, value);
  };

  const FilterGroup = ({ title, options, filterKey, icon }) => (
    <div className="space-y-3">
      <div className="flex items-center space-x-2">
        <Icon name={icon} size={18} color="var(--color-primary)" />
        <h4 className="font-semibold text-text-primary">{title}</h4>
      </div>
      <div className="flex flex-wrap gap-2">
        {options?.map((option) => (
          <button
            key={option?.value}
            onClick={() => handleFilterClick(filterKey, option?.value)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
              filters?.[filterKey] === option?.value
                ? 'bg-primary text-primary-foreground shadow-forest'
                : 'bg-muted text-text-secondary hover:bg-primary/10 hover:text-primary'
            }`}
          >
            <Icon name={option?.icon} size={14} />
            <span>{option?.label}</span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="bg-card rounded-2xl p-6 shadow-lg">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <Icon name="Filter" size={24} color="var(--color-primary)" />
          <h3 className="font-playfair font-bold text-xl text-text-primary">
            Filtrar Projetos
          </h3>
        </div>
        {activeFiltersCount > 0 && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
            className="text-text-secondary hover:text-primary"
          >
            Limpar ({activeFiltersCount})
          </Button>
        )}
      </div>

      <div className="space-y-6">
        <FilterGroup 
          title="Categoria" 
          options={categoryTypes} 
          filterKey="category" 
          icon="Home" 
        />
        
        <div className="border-t border-border pt-6">
          <FilterGroup
            title="Estilo"
            options={styleTypes}
            filterKey="style"
            icon="Palette"
          />
        </div>
        
        <div className="border-t border-border pt-6">
          <FilterGroup
            title="Orçamento"
            options={budgetRanges}
            filterKey="budget"
            icon="DollarSign"
          />
        </div>
      </div>

      {/* Quick Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-2xl font-bold text-primary">150+</p>
            <p className="text-xs text-text-secondary">Projetos</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-accent">98%</p>
            <p className="text-xs text-text-secondary">Satisfação</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-success">5★</p>
            <p className="text-xs text-text-secondary">Avaliação</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFilters;